var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded pb-1",class:_vm.bgWhite ? 'bg-white shadow-md' : ''},[_c('header',{staticClass:"px-6 py-4 flex items-center border-b-2 border-gray-200"},[_vm._t("header")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }